import React, { useState } from "react";
import { toast } from "react-hot-toast";
import useFiles from "../context/FileContext";
import { useNavigate } from "react-router-dom";
import {  useEffect, useRef } from "react";
import { deleteFolder } from "../api/folderapi";
import Loader from "./Loader";

const MenuComponent = ({
  setMenuOpenId,
  setRenamingId,
  renameValue,
  setRenameValue,
  file,
  showShareModal,
  setShowShareModal,
  showInfoModal,
  setShowInfoModal,
  setInfoFile,
 datas
}) => {
  const {
    files,
    setFiles,
    setProgress,
    setIsDownloading,
  } = useFiles();

  const [copiedFile, setCopiedFile] = useState(null);
  const navigate = useNavigate();
  const menuRef = useRef(null);
  


  const menuItems = [
    { label: "Rename", icon: "/assets/Rename.png" },
   /*  {
      label: "Share",
      icon: "/assets/Share.png",
      arrow: "/assets/Right arrow.png",
    }, */
    { label: "Download", icon: "/assets/Download.png" },
   /*  { label: "Move to safe folder", icon: "/assets/safe folder.png" }, */
    {
      label: "File information",
      icon: "/assets/info.png",
      arrow: "/assets/Right arrow.png",
    },
    { label: "Move to bin", icon: "/assets/bin.png", danger: true },
  ];

  const closeMenu = () => setMenuOpenId(null);

/*   
      const handleDownload = async (_id) => {
    const blobUrl = 'https://azerocrm.blob.core.windows.net/azero/0.1402877955960824-HOLIDAY%20VALLEY%20JPEG%40300x-100.jpg';
    setIsDownloading(true);
    setProgress(0);

    try {
      const response = await fetch(blobUrl);
      if (!response.ok) throw new Error('Network response was not ok');

      const contentLength = response.headers.get('content-length');
      if (!contentLength) throw new Error('Content-Length not available');

      const total = parseInt(contentLength, 10);
      let loaded = 0;

      const reader = response.body.getReader();
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
        loaded += value.length;

        const percent = Math.round((loaded / total) * 100);
        setProgress(percent);
      }

      const blob = new Blob(chunks);
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = 'filename.ext'; 
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Fetch download failed:', error);
    } finally {
      setIsDownloading(false);
    }
  }; */

  
  
const handleDownload = async (fileUrl, fileName) => {
  if (!fileUrl || typeof fileUrl !== "string") {
    console.error("fileUrl received:", fileUrl);
    alert("Download URL is missing or invalid!");
    return;
  }

  try {
    const a = document.createElement("a");
    a.href = fileUrl;
    a.download = fileName || fileUrl.split("/").pop();
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    console.error("Download failed:", error);
    alert("Unable to download this file.");
  }
};








const handleDelete = async (_id) => {
  try {
   
    await deleteFolder(_id);
   const updatedData = datas?.filter((item) => item._id !== _id);
    setFiles(updatedData);
     closeMenu()
    toast("Folder deleted successfully");

  } catch (error) {
    console.error(error);
  }
};

 


  
   useEffect(() => {
      const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
         closeMenu();
         
        }
      };
  
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

  return (
    <div className="absolute right-0 mt-2 w-[150px] md:w-[200px] h-auto bg-white overflow-y-auto rounded-md border shadow-md z-20"  ref={menuRef}>
      <ul>
      {menuItems.map((item, idx) => (
        <li
          key={idx}
          className={`relative flex items-center gap-3 px-5 py-2 hover:bg-third hover:text-secondary font-semibold cursor-pointer rounded-md ${
            item.danger ? " font-semibold" : ""
          }`}
          onClick={() => {
            if (item.label === "Move to bin") {
              handleDelete(file._id); 
            } else if (item.label === "Rename") {
              setRenamingId(file._id);
              setRenameValue(file.name);
              closeMenu();
            
            } else if (item.label === "Download") {
              handleDownload(file.url, file.name);
               closeMenu(); 
            } else if (item.label === "Copy") {
              setCopiedFile(file);
              toast.success("Copied successfully");
              closeMenu();
            } else if (item.label === "Share") {
              setShowShareModal(true);
              closeMenu();
            } else if (item.label === "File information") {
              setInfoFile(file);
              setShowInfoModal(true);
              closeMenu();
            } else if (item.label === "Move to safe folder") {
              localStorage.setItem("safeFolderItem", JSON.stringify(file));
              navigate("/safeFolder");
              closeMenu();
            }
          }}
        >
          <img src={item.icon} alt={item.label} className="w-4 h-4" />
          <span>{item.label}</span>
          {item.arrow && (
            <img
              src={item.arrow}
              alt="arrow"
              className="w-5 h-5 absolute right-4"
            />
          )}
        </li>
      ))}
    </ul>
    </div>
  );
};

export default MenuComponent;
